export default __webpack_public_path__ + "images/bar-code+border.svg";